export const QuestionsIcon = ({ height, width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      version='1.1'
      height={height}
      width={width}
      x='0'
      y='0'
      viewBox='0 0 682.667 682.667'
      style={{ enableBackground: 'new 0 0 512 512' }}
      xmlSpace='preserve'
      className=''>
      <g>
        <defs>
          <clipPath id='a'>
            <path d='M0 512h512V0H0Z' fill='#000000' opacity='1' data-original='#000000' />
          </clipPath>
        </defs>
        <g clipPath='url(#a)' transform='matrix(1.33333 0 0 -1.33333 0 682.667)'>
          <path
            d='M0 0c0 88.665 72.515 160.394 161.474 159.114 86.17-1.24 156.239-71.908 156.783-158.086.305-48.26-20.881-91.575-54.544-120.954-3.552-3.1-3.041-8.759 1.017-11.16l29.985-17.741c4.847-2.868 2.812-10.3-2.82-10.298l-135.778.033C69.623-157.484 0-86.877 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
            transform='translate(186.24 166.625)'
            fill='#ede9fe'
            data-original='#7acaa6'
            className=''
            opacity='1'
          />
          <path
            d='m0 0-29.984 17.741c-4.058 2.401-4.57 8.059-1.017 11.16C2.662 58.28 23.848 101.595 23.542 149.856c-.544 86.177-70.613 156.845-156.783 158.085a161.435 161.435 0 0 1-17.362-.691c80.28-7.572 143.628-75.472 144.145-157.394.306-48.261-20.88-91.576-54.543-120.955-3.553-3.101-3.041-8.759 1.017-11.16L-30 0c4.821-2.852 2.831-10.212-2.731-10.291l29.911-.007C2.813-10.3 4.848-2.868 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
            transform='translate(480.954 17.798)'
            fill='#c4b5fd'
            data-original='#57be92'
            className=''
            opacity='1'
          />
          <path
            d='M0 0c-1.245.047-2.493.083-3.745.101-88.958 1.28-161.473-70.449-161.473-159.114 0-2.032.05-4.052.126-6.066C-78.204-155.907-9.17-86.888 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
            transform='translate(351.457 325.638)'
            fill='#c4b5fd'
            data-original='#57be92'
            className=''
            opacity='1'
          />
          <path
            d='M0 0c0 88.665-72.515 160.394-161.474 159.113-86.17-1.239-156.239-71.907-156.783-158.085-.305-48.261 20.881-91.575 54.544-120.954 3.552-3.101 3.041-8.759-1.017-11.16l-29.985-17.741c-4.847-2.868-2.812-10.3 2.82-10.298l135.778.033C-69.623-157.485 0-86.878 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
            transform='translate(325.76 345.37)'
            fill='#d1fae5'
            data-original='#8795de'
            className=''
            opacity='1'
          />
          <path
            d='M0 0a158.916 158.916 0 0 1-12.638-.692c80.841-7.569 144.112-75.602 144.112-158.422 0-86.878-69.623-157.485-156.117-159.092l-105.867-.026c.031 0 .058-.007.089-.007l135.778.033c86.494 1.607 156.117 72.214 156.117 159.092C161.474-70.449 88.958 1.28 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
            transform='translate(164.287 504.483)'
            fill='#a7f3d0'
            data-original='#6c7fd8'
            className=''
            opacity='1'
          />
          <path
            d='M0 0c0-9.229 7.481-16.709 16.709-16.709 9.229 0 16.71 7.48 16.71 16.709s-7.481 16.709-16.71 16.709C7.481 16.709 0 9.229 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
            transform='translate(149.92 237.6)'
            fill='#ffffff'
            data-original='#ffffff'
          />
          <path
            d='M0 0c-8.284 0-15 6.716-15 15v53.417c0 8.285 6.716 15 15 15 9.986 0 19.279 3.996 26.167 11.25 6.883 7.25 10.387 16.758 9.867 26.774-.974 18.763-16.472 33.758-35.281 34.137-18.315.371-33.969-12.969-36.487-31.025a36.452 36.452 0 0 1-.35-5.052c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 3.077.215 6.172.638 9.2 4.555 32.649 32.568 56.884 65.452 56.884.45 0 .899-.004 1.35-.013 34.46-.695 62.852-28.181 64.637-62.575.951-18.315-5.467-35.711-18.07-48.986C38.996 64.609 27.47 58.088 15 55.161V15C15 6.716 8.284 0 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
            transform='translate(166.63 284.269)'
            fill='#ffffff'
            data-original='#ffffff'
          />
          <path
            d='M0 0c0-9.228 7.481-16.709 16.709-16.709 9.229 0 16.71 7.481 16.71 16.709 0 9.229-7.481 16.709-16.71 16.709C7.481 16.709 0 9.229 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
            transform='translate(328.66 166.628)'
            fill='#ffffff'
            data-original='#ffffff'
          />
          <path
            d='M0 0c0-9.228 7.481-16.709 16.709-16.709 9.229 0 16.71 7.481 16.71 16.709 0 9.229-7.481 16.709-16.71 16.709C7.481 16.709 0 9.229 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
            transform='translate(403.66 166.628)'
            fill='#ffffff'
            data-original='#ffffff'
          />
          <path
            d='M0 0c0-9.228 7.481-16.709 16.709-16.709 9.229 0 16.71 7.481 16.71 16.709 0 9.229-7.481 16.709-16.71 16.709C7.481 16.709 0 9.229 0 0'
            style={{ fillOpacity: 1, fillRule: 'nonzero', stroke: 'none' }}
            transform='translate(253.66 166.628)'
            fill='#ffffff'
            data-original='#ffffff'
          />
          <path
            d='M0 0c7.568-79.764 74.013-142.366 155.401-143.881l135.77-.03c5.641 0 7.67 7.431 2.821 10.3l-29.98 17.74c-4.06 2.4-4.571 8.06-1.02 11.161 33.67 29.379 54.849 72.689 54.55 120.949-.55 86.18-70.621 156.85-156.791 158.091a162.104 162.104 0 0 1-23.33-1.351'
            style={{
              strokeWidth: 15,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(186.958 151.41)'
            fill='none'
            stroke='#000000'
            strokeWidth='15'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            className=''
          />
          <path
            d='M0 0c-29.944-28.799-48.722-69.123-49.003-113.574-.305-48.261 20.881-91.575 54.544-120.954 3.553-3.101 3.041-8.759-1.017-11.16l-29.984-17.741c-4.848-2.868-2.813-10.3 2.819-10.299l135.779.034c86.493 1.607 156.116 72.214 156.116 159.092 0 88.665-72.515 160.394-161.474 159.113-29.764-.428-57.608-9.14-81.328-23.913'
            style={{
              strokeWidth: 15,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(56.506 459.972)'
            fill='none'
            stroke='#000000'
            strokeWidth='15'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            className=''
          />
          <path
            d='M0 0c0-9.229 7.481-16.709 16.709-16.709 9.229 0 16.71 7.48 16.71 16.709s-7.481 16.709-16.71 16.709C7.481 16.709 0 9.229 0 0Z'
            style={{
              strokeWidth: 15,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(149.92 237.6)'
            fill='none'
            stroke='#000000'
            strokeWidth='15'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            className=''
          />
          <path
            d='M0 0c-8.284 0-15 6.716-15 15v53.417c0 8.285 6.716 15 15 15 9.986 0 19.279 3.996 26.167 11.25 6.883 7.25 10.387 16.758 9.867 26.774-.974 18.763-16.472 33.758-35.281 34.137-18.315.371-33.969-12.969-36.487-31.025a36.452 36.452 0 0 1-.35-5.052c0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 3.077.215 6.172.638 9.2 4.555 32.649 32.568 56.884 65.452 56.884.45 0 .899-.004 1.35-.013 34.46-.695 62.852-28.181 64.637-62.575.951-18.315-5.467-35.711-18.07-48.986C38.996 64.609 27.47 58.088 15 55.161V15C15 6.716 8.284 0 0 0Z'
            style={{
              strokeWidth: 15,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(166.63 284.269)'
            fill='none'
            stroke='#000000'
            strokeWidth='15'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            className=''
          />
          <path
            d='M0 0c0-9.228 7.481-16.709 16.709-16.709 9.229 0 16.71 7.481 16.71 16.709 0 9.229-7.481 16.709-16.71 16.709C7.481 16.709 0 9.229 0 0Z'
            style={{
              strokeWidth: 15,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(328.66 166.628)'
            fill='none'
            stroke='#000000'
            strokeWidth='15'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            className=''
          />
          <path
            d='M0 0c0-9.228 7.481-16.709 16.709-16.709 9.229 0 16.71 7.481 16.71 16.709 0 9.229-7.481 16.709-16.71 16.709C7.481 16.709 0 9.229 0 0Z'
            style={{
              strokeWidth: 15,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(403.66 166.628)'
            fill='none'
            stroke='#000000'
            strokeWidth='15'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            className=''
          />
          <path
            d='M0 0c0-9.228 7.481-16.709 16.709-16.709 9.229 0 16.71 7.481 16.71 16.709 0 9.229-7.481 16.709-16.71 16.709C7.481 16.709 0 9.229 0 0Z'
            style={{
              strokeWidth: 15,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 10,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
            transform='translate(253.66 166.628)'
            fill='none'
            stroke='#000000'
            strokeWidth='15'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
            strokeDasharray='none'
            strokeOpacity=''
            data-original='#000000'
            className=''
          />
        </g>
      </g>
    </svg>
  );
};
